import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	recommendedProjectsHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recommendedProjectsHeadingSpaces: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recommendedProjectsHeading: {
		id: 'projects-directory-v3-recommendations.recommended-projects-heading',
		defaultMessage: 'Recommended projects',
		description: 'Heading for recommended projects section',
	},
	recommendedProjectsHeadingSpaces: {
		id: 'projects-directory-v3-recommendations.recommendations-list.recommended-projects-heading-spaces',
		defaultMessage: 'Recommended spaces',
		description: 'Heading for recommended spaces section',
	},
});
export default messages;
